import { render, staticRenderFns } from "./PriceOffer.vue?vue&type=template&id=1b94db32&"
import script from "./PriceOffer.vue?vue&type=script&lang=js&"
export * from "./PriceOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports